import React from 'react'
import { twMerge } from 'tailwind-merge'
import { DropdownMenuItem } from '@components/ui/dropdown-menu'

const Item = ({ children, className, ...props }) => {
  return (
    <DropdownMenuItem
      className={twMerge(
        className,
        'text-lg',
        'block px-4 py-2 text-sm'
      )}
      {...props}
    >
      {children}
    </DropdownMenuItem>
  )
}

export default Item
